var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76098684,4.83448054 C5.93760355,5.14070072 5.7159093,5.52348072 5.36315431,5.52348072 L0.771330436,5.52348072 C0.417896081,5.52348072 0.197225667,5.1401073 0.373497906,4.83448054 L2.66943855,0.852603721 C2.84614138,0.546239978 3.28871655,0.546795107 3.46510361,0.852603721 L5.76098684,4.83448054 Z M3.06727108,4.01123506 C2.8241815,4.01123506 2.62711676,4.20835341 2.62711676,4.45150911 C2.62711676,4.69466482 2.8241815,4.89178317 3.06727108,4.89178317 C3.31036066,4.89178317 3.50742541,4.69466482 3.50742541,4.45150911 C3.50742541,4.20835341 3.31036066,4.01123506 3.06727108,4.01123506 Z M2.64938282,2.42867955 L2.72036249,3.73035936 C2.72368279,3.79127031 2.77403261,3.83895391 2.83501313,3.83895391 L3.29952904,3.83895391 C3.36050955,3.83895391 3.41085937,3.79127031 3.41417967,3.73035936 L3.48515934,2.42867955 C3.48874755,2.36288729 3.43637876,2.3075659 3.3705087,2.3075659 L2.76402389,2.3075659 C2.69815384,2.3075659 2.64579461,2.36288729 2.64938282,2.42867955 L2.64938282,2.42867955 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation-triangle.8fb170fe192de26f8f4ca46170f0a437.svg";
export { ForwardRef as ReactComponent };